import React, { useContext, useRef, useState } from "react";
import styles from "./styles/calendar.module.css";
import { useEffect } from "react";

function CCCalendar({
  handleDate,
  parentDate_,
  className,
  disabled = false,
  yyyy,
  mm,
  dd,
}) {
  const today = new Date();
  // const parentDate = parentDate_?parentDate_:`${today.getFullYear()}/${(today.getMonth()+1)<10?"0"+String(today.getMonth()+1):today.getMonth()+1}/${today.getDate()}`
  const parentDate = parentDate_ ? parentDate_ : `${""}/${""}/${""}`;
  const yearInputRef = useRef(null);
  const monthInputRef = useRef(null);
  const dayInputRef = useRef(null);

  const [yearValue, setYearValue] = useState(parentDate.split("/")[0]);
  const [monthValue, setMonthValue] = useState(parentDate.split("/")[1]);
  const [dayValue, setDayValue] = useState(parentDate.split("/")[2]);

  const handleChange = (event, maxLength, nextInputRef, setValue) => {
    const inputValue = event.target.value.replace(/\D/g, "");
    if (inputValue.length <= maxLength) {
      setValue(inputValue);
      if (inputValue.length === maxLength) {
        try {
          nextInputRef.current.focus();
        } catch {
          return;
        }
      }
    }
  };
  /*
    A single digit becomes two when the field is left.

    The date is emitted as YYYY/MM/DD and read back by a regex that wants two
    digits in each of the last two places, so a month typed as "2" produced
    "2026/2/22" and was rejected as malformed — with nothing on screen to say
    that "2" was the problem. Typing "02" always worked, which is why this went
    unnoticed.

    Padded on blur rather than on change: doing it per keystroke would turn the
    "1" of an intended "12" into "01" before the second digit arrived.

    "0" is left alone. Padding it to "00" would satisfy the regex and name no
    month, which is worse than failing.
  */
  const padOnBlur = (setValue) => () =>
    setValue((value) =>
      value.length === 1 && Number(value) >= 1 ? `0${value}` : value
    );

  useEffect(() => {
    handleDate(`${yearValue}/${monthValue}/${dayValue}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yearValue, monthValue, dayValue]);
  return (
    <div
      disabled={disabled}
      className={`${styles.calendar} ${className ? styles.input_error : ""}`}
    >
      <input
        className={styles.input_calendar}
        type="text"
        maxLength="4"
        value={yearValue}
        placeholder={yyyy?.toUpperCase() || "YYYY"}
        onChange={(event) => {
          if (Number(event.target.value > today.getFullYear()))
            event.target.value = today.getFullYear();
          handleChange(event, 4, monthInputRef, setYearValue);
        }}
        ref={yearInputRef}
      />
      <span>/</span>
      <input
        type="text"
        className={styles.input_calendar}
        maxLength="2"
        value={monthValue}
        placeholder={mm?.toUpperCase() || "MM"}
        onChange={(event) => {
          if (Number(event.target.value) > 12) return;
          if (
            Number(yearValue) === today.getFullYear() &&
            Number(event.target.value) > today.getMonth() + 1
          )
            event.target.value = "0" + String(today.getMonth() + 1);
          handleChange(event, 2, dayInputRef, setMonthValue);
        }}
        onBlur={padOnBlur(setMonthValue)}
        ref={monthInputRef}
      />
      <span>/</span>
      <input
        type="text"
        className={styles.input_calendar}
        maxLength="2"
        value={dayValue}
        placeholder={dd?.toUpperCase() || "DD"}
        onChange={(event) => {
          if (Number(event.target.value) > 31) return;
          if (
            Number(yearValue) === today.getFullYear() &&
            Number(monthValue) === today.getMonth() + 1 &&
            Number(event.target.value) > today.getDate()
          )
            event.target.value = String(today.getDate());
          handleChange(event, 2, null, setDayValue);
        }}
        onBlur={padOnBlur(setDayValue)}
        ref={dayInputRef}
      />
      {/* <div className={styles.calendar_right} onClick={()=>null}></div> */}
    </div>
  );
}

export default CCCalendar;
